module.exports = __webpack_public_path__ + "img/1791993220950.85be5849.png";